<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.edit') }} {{ $tc('message.association', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-form  @reset="onReset" v-if="show">
                    <b-container>
                        <b-row>
                            <b-col sm="12">
                                <span  class="obligatoire justify-center">*</span>

                                <b-form-group
                                        id="single-group"
                                        :label="$t('message.select')+' '+$tc('message.region', 1)"
                                        label-for="regions">
                                    <!-- Options -->
                                    <slim-element return-value="text" selected-id="regions" :afficher="true" :element.sync="$v.form.region.$model" :data.sync="mRegions"></slim-element>
                                    <b-form-invalid-feedback v-if="errorshasField('regions')">
                                        {{ getErrorsField('regions') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-if="$v.form.region.$error">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                </b-form-group>

                            </b-col>
                            </b-row>
                            <b-row>
                            <b-col sm="12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="nom-group"
                                        :label="$tc('message.cities',1)"
                                        label-for="ville"
                                        description=""

                                >

                                    <b-form-input
                                            id="ville"
                                            v-model="$v.form.ville.$model"
                                            :state="$v.form.ville.$dirty ? !(errorshasField('ville') || $v.form.ville.$error) : null"
                                            type="text"
                                            placeholder=""
                                            @focus="clearErrorField('ville')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback  v-if="!$v.form.ville.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('ville')">
                                        {{ getErrorsField('ville') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            </b-row>
                            <b-row>
                            </b-row>
                            <b-row>
                            <b-col sm="12">

                                <b-form-group
                                        id="prenom-group"
                                        :label="$t('message.address')"
                                        label-for="nom"
                                >
                                    <b-form-input
                                            id="nom"
                                            v-model="$v.form.localisation.$model"
                                            type="text"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                            </b-row>
                            <b-row>
                            <b-col sm="12">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="telephone-group"
                                        :label="$t('message.phoneNumber')"
                                        label-for="telephone"
                                >
                                    <b-form-input
                                            id="telephone"
                                            v-model="$v.form.telephone.$model"
                                            :state="$v.form.telephone.$dirty ? !(errorshasField('telephone') || $v.form.telephone.$error) : null"
                                            placeholder=""
                                            @focus="clearErrorField('telephone')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.telephone.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="!$v.form.telephone.numeric">
                                        {{ $t('message.integer', { n: 9 }) }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="!$v.form.telephone.minLength">
                                        {{ $t('message.minCharacters', { n: 9 }) }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('telephone')">
                                        {{ getErrorsField('telephone') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            </b-row>
                            <b-row>
                            <b-col sm="12">
                                <span  class="obligatoire">*</span>

                                <b-form-group
                                        id="email-group"
                                        :label="$t('message.email')"
                                        label-for="email"
                                >
                                    <b-form-input
                                            id="email"
                                            v-model="$v.form.email.$model"
                                            :state="$v.form.email.$dirty ? !(errorshasField('email') || $v.form.email.$error) : null"
                                            type="email"
                                            placeholder=""
                                            @focus="clearErrorField('email')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.email.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="!$v.form.email.email">
                                        {{ $t('message.emailNotValid') }}
                                    </b-form-invalid-feedback>

                                    <b-form-invalid-feedback v-else-if="errorshasField('email')">
                                        {{ getErrorsField('email') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            </b-row>
                    </b-container>
                    <b-container>
                        <b-row class="justify-content-sm-center" v-if="can">
                            <b-button  variant="primary" @click="onSubmit">
                                {{ $t('message.edit') }}
                            </b-button>
                        </b-row>
                    </b-container>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required, email, minLength,integer } from 'vuelidate/lib/validators';
    import _ from 'lodash';
    import SlimSelect from 'slim-select';
    import AppConfig from '../../constants/AppConfig';
    import SlimElement from "../Layout/SlimElement";

    export default {
        name: "EditAssociation",
        components: {
            SlimElement,
        },
        computed: {
            ...mapGetters(["Association", "countries",  "partenaires", "regions", "errors",'hasAdminRole',
                'hasGestionnaireRole','hasMedecinControleRole','hasAssistante']),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasMedecinControleRole || this.hasAssistante;
            },

            userIsMed:function(){
                return (JSON.parse(localStorage.getItem('user')))['isMedicasure'];
            },

            form: function() {
                let self = this;
                let f = this.Association;
                return f;
            },

            mRegions: function() {
                let cArray = [];

                _.forOwn(this.regions, function(value, key) {
                    cArray.push({ text: value.fr_description, id: value.id });
                });
             
                return cArray;
            },

        },

        data() {
            return {
                association_id: this.$route.params.association,
                show: true,
            }
        },

        methods: {

            getAssociation() {
                let args = {
                    association: this.association_id
                };

                this.$store.dispatch("getAssociation", { args });
            },

            getRegions: function() {
                let args = {};
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getRegions', { args, errorMessages });
            },


            onSubmit: function(evt) {
                evt.preventDefault();
                this.$v.$touch();
                if(!this.$v.$invalid) {
                    
                    let args = {};
                    args = this.form;
                    args.telephone = this.form.telephone;

                    let successMessage = this.$i18n.t('message.partnerUpdated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('updateAssociation', { args:args, errorMessages, successMessage })
                        .then(() => {
                            // Scroll to the top of the page
                            document.body.scrollTop = 0; // For Safari
                            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                        });
                }
            },

            onReset: function(evt) {
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            }
        },

        validations: {
            form: {
                nom: {
                    required
                },
                contact: {
                    required
                },
                localisation: {
                    required
                },
                telephone: {
                    required,
                    minLength: minLength(9)
                },
                email: {
                    required,
                    email
                },
                region: {
                    required,
                },
                ville: {
                    required
                },
            }
        },

        mounted() {
            // Retrieve list of countries
            this.getRegions();
        }
    }
</script>

<style scoped>
    @import url('~slim-select/dist/slimselect.min.css');
</style>